
import type { PropType } from 'vue'
import type { QueryRankingElementActionConfig } from '../../composables/use-query-ranking-element-actions-config'
import type { ConfigurationsMessages } from '../../models/i18n/tools.messages'
import { RankingActionEnum } from '@empathybroker/tsclient-play/dist/enums/ranking-action.enum'

import { PinProductAction } from '@empathyco/playboard-core-domain'

import { defineComponent } from 'vue'

import { ColorEnum } from '../../enums'

import { EpbBadge } from '../shared/epb-badge'

export default defineComponent({
  name: 'ConfigurationsResultCardFooter',
  components: {
    EpbBadge,
  },
  props: {
    action: {
      type: String as PropType<QueryRankingElementActionConfig['action']>,
      required: true,
    },
    messages: {
      type: Object as PropType<ConfigurationsMessages['status']>,
      required: true,
    },
  },
  data() {
    const config = {
      [RankingActionEnum.BOOST]: { color: ColorEnum.GREEN_75, icon: 'arrowup' },
      [RankingActionEnum.BURY]: { color: ColorEnum.RED_75, icon: 'arrowdown' },
      [PinProductAction]: { color: ColorEnum.YELLOW_75, icon: 'pin' },
    }[this.$props.action]
    return {
      baseClass: 'epb-configurations-result-card-footer',
      color: config.color,
      icon: config.icon,
      label: this.$props.messages[this.$props.action],
    }
  },
})
